import { createContext } from "react";
import type { SetOpenAddWidgetDialog } from "../OpenAddWidgetDialogProvider.types";

const OpenAddWidgetDialogHandlersContext = createContext<SetOpenAddWidgetDialog | undefined>(undefined);
OpenAddWidgetDialogHandlersContext.displayName = "OpenAddWidgetDialogHandlersContext";

export default OpenAddWidgetDialogHandlersContext;
